<template>
  <el-image :src="src" :style="{ width,height }" :fit="fit" :preview-src-list="srcList">
    <div slot="placeholder" class="image-slot">
      <template v-if="type === 'common'">
        <img src="@/assets/placeholder.jpg" alt="加载失败">
      </template>
      <template v-else>
        <img src="@/assets/user-placeholder.png" alt="加载失败">
      </template>
    </div>
    <div slot="error" class="image-slot">
      <template v-if="type === 'common'">
        <img src="@/assets/placeholder.jpg" alt="加载失败">
      </template>
      <template v-else>
        <img src="@/assets/user-placeholder.png" alt="加载失败">
      </template>
    </div>
  </el-image>
</template>

<script setup>
import { computed } from 'vue'
const props = defineProps({
  src: {
    type: String,
    default: () => ''
  },
  width: {
    type: String,
    default: () => ''
  },
  height: {
    type: String,
    default: () => ''
  },
  fit: {
    type: String,
    default: () => 'contain'
  },
  type: {
    type: String,
    default: () => 'common'
  }
})
const width = computed(() => {
  return props.width
})
const type = computed(() => {
  return props.type
})
const height = computed(() => {
  return props.height
})
const src = computed(() => {
  return props.src
})
const fit = computed(() => {
  return props.fit
})
const srcList = computed(() => {
  return [props.src]
})
</script>

<style lang="scss" scoped>
  .image-slot {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    img {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
</style>
